export default {
  author: {
    name: 'Liu'
  },
  login: {
    title: 'Clover Blog System',
    account: 'Account',
    password: 'Pwd',
    remember: 'Remember',
    login: 'Login',
    register: 'Register'
  },
  register: {
    title: 'Welcome,Register',
    account: 'Account',
    e_mail: 'E-MAil',
    password: 'Pwd',
    again_pass: 'Again it',
    register: 'Register'
  },
  error: {
    title: 'Oh no!!',
    line1: 'You’re either misspelling the URL',
    line2: "or requesting a page that's no longer here.",
    back: 'Back to previous page'
  },
  navbar: {
    title: 'vue-cms',
    screenfull: 'screenfull',
    profile: 'Profile',
    avatar: 'Avatar',
    github: 'GitHub',
    logOut: 'Log Out'
  },
  router: {
    dashboard: 'Dashboard',
    homepage: 'Homepage',
    account: 'Account',
    guide: 'Guide',
    introduction: 'Introduction',
    media: 'Media',
    icon: 'Icon',
    todo: 'Todo',
    external_link: 'External Link',
    theme: 'Theme',
    essay: 'Essay',
    post_new: 'Post New',
    all_essay: 'All Essay',
    category: 'Category',
    essay_detail: 'Essay Detail',
    category_detail: 'Category Detail'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js